import { usePageLoader } from '@/hooks/usePageLoader';
import { useSnackbar } from '@/hooks/useSnackbar';
import { ibowClient } from '@/init/ibowClient';
import {
  DoubleLoginResolver,
  DoubleLoginType,
} from '@/schemas/DoubleLoginSchema';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

type LogicProps = {
  setTmpToken: (value: string) => void;
};

export const useLogic = ({ setTmpToken }: LogicProps) => {
  const searchParams = useSearchParams();
  const token = searchParams.get('check_token');
  const { openSnackbar } = useSnackbar();
  const { setLoading } = usePageLoader();
  const { control, reset, handleSubmit } = useForm<DoubleLoginType>({
    resolver: DoubleLoginResolver,
    defaultValues: { token: token || '' },
  });

  const onClickSubmit = handleSubmit((data) => {
    setLoading(true);
    ibowClient.authentication
      .postCheckPasswordReset({ body: data })
      .then((res) => {
        setTmpToken(res.token);
        setLoading(false);
      })
      .catch((err) => {
        openSnackbar(err.body.message, 'error');
        setLoading(false);
      });
  });

  useEffect(() => {
    reset({ token: token || '' });
  }, [token, reset]);

  return { control, onClickSubmit };
};
